// extracted by mini-css-extract-plugin
module.exports = {"added-column":"added-column_added-column__MYIWh","added-column__date":"added-column_added-column__date__mVxLC","added-column__actions":"added-column_added-column__actions__n2t5C"};